import styled from '@emotion/styled';
import { DrawerKind } from '../../store/ui';

export const GraphViewRoot = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const GraphViewBody = styled('div')({
  flex: 1,
  display: 'flex',
  minHeight: 0,
  position: 'relative',
});

export const GraphCanvasContainer = styled('div')({
  flex: 1,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
});

export const ReactFlowStyle = {
  flex: 1,
  minHeight: 0,
};

export const GraphViewGlobalStyles = {
  '.graph-view .react-flow__node:not(.dragging)': {
    transition: 'transform 160ms ease',
  },
};

export const DrawerContainer = styled('div')<{
  kind: DrawerKind;
}>(({ theme, kind }) => ({
  position: 'absolute',
  zIndex: 1,
  right: 0,
  top: 0,
  bottom: 0,
  width: kind === DrawerKind.None ? 0 : 350,
  overflow: 'hidden',
  transition: 'width 200ms ease',
  display: 'flex',
  minHeight: 0,
  pointerEvents: kind === DrawerKind.None ? 'none' : 'auto',
  borderLeft:
    kind === DrawerKind.NodeConfig || kind === DrawerKind.GraphConfig
      ? `1px solid ${theme.colors.gray[3]}`
      : 'none',
  background: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
}));

export const DrawerContent = styled('div')(() => ({
  display: 'flex',
  minHeight: 0,
  width: '100%',
}));
